export const print = (...args: any) => {
  __DEV__ && console.debug(...args)
}

export const log = print
export const debug = print
